module.exports = __webpack_public_path__ + "static/media/animal-welfare-principles.a4f1068b.jpg";